import { AccountConnectContent } from "@/modules/settings/account/account-connect-content";

export default function AccountConnectPage() {
  return <AccountConnectContent />;
}
